export const link="https://media.aramis.events/api/v1";
export const dataLink="https://media.aramis.events/api/v1/files/download/";
export const countryOptions = [
    { name: "AFG", value: "countries.AFG" },
    { name: "ALB", value: "countries.ALB" },
    { name: "ALG", value: "countries.ALG" },
    { name: "AND", value: "countries.AND" },
    { name: "ANG", value: "countries.ANG" },
    { name: "ANT", value: "countries.ANT" },
    { name: "ARG", value: "countries.ARG" },
    { name: "ARM", value: "countries.ARM" },
    { name: "AUS", value: "countries.AUS" },
    { name: "AUT", value: "countries.AUT" },
    { name: "AZE", value: "countries.AZE" },
    { name: "BAH", value: "countries.BAH" },
    { name: "BRN", value: "countries.BRN" },
    { name: "BAN", value: "countries.BAN" },
    { name: "BAR", value: "countries.BAR" },
    { name: "BLR", value: "countries.BLR" },
    { name: "BEL", value: "countries.BEL" },
    { name: "BIZ", value: "countries.BIZ" },
    { name: "BEN", value: "countries.BEN" },
    { name: "BHU", value: "countries.BHU" },
    { name: "BOL", value: "countries.BOL" },
    { name: "BIH", value: "countries.BIH" },
    { name: "BOT", value: "countries.BOT" },
    { name: "BRA", value: "countries.BRA" },
    { name: "BRU", value: "countries.BRU" },
    { name: "BUL", value: "countries.BUL" },
    { name: "BUR", value: "countries.BUR" },
    { name: "BDI", value: "countries.BDI" },
    { name: "CPV", value: "countries.CPV" },
    { name: "CAM", value: "countries.CAM" },
    { name: "CMR", value: "countries.CMR" },
    { name: "CAN", value: "countries.CAN" },
    { name: "CAF", value: "countries.CAF" },
    { name: "CHA", value: "countries.CHA" },
    { name: "CHI", value: "countries.CHI" },
    { name: "CHN", value: "countries.CHN" },
    { name: "COL", value: "countries.COL" },
    { name: "COM", value: "countries.COM" },
    { name: "COD", value: "countries.COD" },
    { name: "COK", value: "countries.COK" },
    { name: "CRC", value: "countries.CRC" },
    { name: "CIV", value: "countries.CIV" },
    { name: "CRO", value: "countries.CRO" },
    { name: "CUB", value: "countries.CUB" },
    { name: "CYP", value: "countries.CYP" },
    { name: "CZE", value: "countries.CZE" },
    { name: "DEN", value: "countries.DEN" },
    { name: "DJI", value: "countries.DJI" },
    { name: "DMA", value: "countries.DMA" },
    { name: "DOM", value: "countries.DOM" },
    { name: "ECU", value: "countries.ECU" },
    { name: "EGY", value: "countries.EGY" },
    { name: "ESA", value: "countries.ESA" },
    { name: "GEQ", value: "countries.GEQ" },
    { name: "ERI", value: "countries.ERI" },
    { name: "EST", value: "countries.EST" },
    { name: "ETH", value: "countries.ETH" },
    { name: "FIJ", value: "countries.FIJ" },
    { name: "FIN", value: "countries.FIN" },
    { name: "FRA", value: "countries.FRA" },
    { name: "GAB", value: "countries.GAB" },
    { name: "GAM", value: "countries.GAM" },
    { name: "GEO", value: "countries.GEO" },
    { name: "GER", value: "countries.GER" },
    { name: "GHA", value: "countries.GHA" },
    { name: "GRE", value: "countries.GRE" },
    { name: "GRN", value: "countries.GRN" },
    { name: "GUA", value: "countries.GUA" },
    { name: "GUI", value: "countries.GUI" },
    { name: "GBS", value: "countries.GBS" },
    { name: "GUY", value: "countries.GUY" },
    { name: "HAI", value: "countries.HAI" },
    { name: "HON", value: "countries.HON" },
    { name: "HUN", value: "countries.HUN" },
    { name: "ISL", value: "countries.ISL" },
    { name: "IND", value: "countries.IND" },
    { name: "INA", value: "countries.INA" },
    { name: "IRI", value: "countries.IRI" },
    { name: "IRQ", value: "countries.IRQ" },
    { name: "IRL", value: "countries.IRL" },
    { name: "ISR", value: "countries.ISR" },
    { name: "ITA", value: "countries.ITA" },
    { name: "JAM", value: "countries.JAM" },
    { name: "JPN", value: "countries.JPN" },
    { name: "JOR", value: "countries.JOR" },
    { name: "KAZ", value: "countries.KAZ" },
    { name: "KEN", value: "countries.KEN" },
    { name: "KIR", value: "countries.KIR" },
    { name: "KUW", value: "countries.KUW" },
    { name: "KGZ", value: "countries.KGZ" },
    { name: "LAO", value: "countries.LAO" },
    { name: "LAT", value: "countries.LAT" },
    { name: "LIB", value: "countries.LIB" },
    { name: "LES", value: "countries.LES" },
    { name: "LBR", value: "countries.LBR" },
    { name: "LBA", value: "countries.LBA" },
    { name: "LIE", value: "countries.LIE" },
    { name: "LTU", value: "countries.LTU" },
    { name: "LUX", value: "countries.LUX" },
    { name: "MKD", value: "countries.MKD" },
    { name: "MAD", value: "countries.MAD" },
    { name: "MAW", value: "countries.MAW" },
    { name: "MAS", value: "countries.MAS" },
    { name: "MDV", value: "countries.MDV" },
    { name: "MLI", value: "countries.MLI" },
    { name: "MLT", value: "countries.MLT" },
    { name: "MHL", value: "countries.MHL" },
    { name: "MTN", value: "countries.MTN" },
    { name: "MRI", value: "countries.MRI" },
    { name: "MEX", value: "countries.MEX" },
    { name: "FSM", value: "countries.FSM" },
    { name: "MDA", value: "countries.MDA" },
    { name: "MON", value: "countries.MON" },
    { name: "MGL", value: "countries.MGL" },
    { name: "MNE", value: "countries.MNE" },
    { name: "MAR", value: "countries.MAR" },
    { name: "MOZ", value: "countries.MOZ" },
    { name: "MYA", value: "countries.MYA" },
    { name: "NAM", value: "countries.NAM" },
    { name: "NRU", value: "countries.NRU" },
    { name: "NEP", value: "countries.NEP" },
    { name: "NED", value: "countries.NED" },
    { name: "NZL", value: "countries.NZL" },
    { name: "NCA", value: "countries.NCA" },
    { name: "NIG", value: "countries.NIG" },
    { name: "NGR", value: "countries.NGR" },
    { name: "NIU", value: "countries.NIU" },
    { name: "PFK", value: "countries.PFK" },
    { name: "NOR", value: "countries.NOR" },
    { name: "OMA", value: "countries.OMA" },
    { name: "PAK", value: "countries.PAK" },
    { name: "PLW", value: "countries.PLW" },
    { name: "PLE", value: "countries.PLE" },
    { name: "PAN", value: "countries.PAN" },
    { name: "PNG", value: "countries.PNG" },
    { name: "PAR", value: "countries.PAR" },
    { name: "PER", value: "countries.PER" },
    { name: "PHI", value: "countries.PHI" },
    { name: "POL", value: "countries.POL" },
    { name: "POR", value: "countries.POR" },
    { name: "QAT", value: "countries.QAT" },
    { name: "ROU", value: "countries.ROU" },
    { name: "RUS", value: "countries.RUS" },
    { name: "RWA", value: "countries.RWA" },
    { name: "SKN", value: "countries.SKN" },
    { name: "LCA", value: "countries.LCA" },
    { name: "VIN", value: "countries.VIN" },
    { name: "SAM", value: "countries.SAM" },
    { name: "SMR", value: "countries.SMR" },
    { name: "STP", value: "countries.STP" },
    { name: "KSA", value: "countries.KSA" },
    { name: "SEN", value: "countries.SEN" },
    { name: "SRB", value: "countries.SRB" },
    { name: "SEY", value: "countries.SEY" },
    { name: "SLE", value: "countries.SLE" },
    { name: "SIN", value: "countries.SIN" },
    { name: "SVK", value: "countries.SVK" },
    { name: "SLO", value: "countries.SLO" },
    { name: "SOL", value: "countries.SOL" },
    { name: "SOM", value: "countries.SOM" },
    { name: "RSA", value: "countries.RSA" },
    { name: "KOR", value: "countries.KOR" },
    { name: "SSD", value: "countries.SSD" },
    { name: "ESP", value: "countries.ESP" },
    { name: "SRI", value: "countries.SRI" },
    { name: "SUD", value: "countries.SUD" },
    { name: "SUR", value: "countries.SUR" },
    { name: "SWZ", value: "countries.SWZ" },
    { name: "SWE", value: "countries.SWE" },
    { name: "SUI", value: "countries.SUI" },
    { name: "SYR", value: "countries.SYR" },
    { name: "TJK", value: "countries.TJK" },
    { name: "TAN", value: "countries.TAN" },
    { name: "THA", value: "countries.THA" },
    { name: "TLS", value: "countries.TLS" },
    { name: "TOG", value: "countries.TOG" },
    { name: "TGA", value: "countries.TGA" },
    { name: "TRI", value: "countries.TRI" },
    { name: "TUN", value: "countries.TUN" },
    { name: "TUR", value: "countries.TUR" },
    { name: "TKM", value: "countries.TKM" },
    { name: "TUV", value: "countries.TUV" },
    { name: "UGA", value: "countries.UGA" },
    { name: "UKR", value: "countries.UKR" },
    { name: "UAE", value: "countries.UAE" },
    { name: "GBR", value: "countries.GBR" },
    { name: "USA", value: "countries.USA" },
    { name: "URU", value: "countries.URU" },
    { name: "UZB", value: "countries.UZB" },
    { name: "VAN", value: "countries.VAN" },
    { name: "VAT", value: "countries.VAT" },
    { name: "VEN", value: "countries.VEN" },
    { name: "VIE", value: "countries.VIE" },
    { name: "YEM", value: "countries.YEM" },
    { name: "ZAM", value: "countries.ZAM" },
    { name: "ZIM", value: "countries.ZIM" }
  ];
